module.exports = __webpack_public_path__ + "media/images/app/become-vendor/prob2-81bea62e97a208a3b2f92124700c2172.webp";